import { render, staticRenderFns } from "./uiInput.vue?vue&type=template&id=2caddfd8&scoped=true"
import script from "./uiInput.vue?vue&type=script&lang=js"
export * from "./uiInput.vue?vue&type=script&lang=js"
import style0 from "./uiInput.vue?vue&type=style&index=0&id=2caddfd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caddfd8",
  null
  
)

export default component.exports